import { useTranslation } from "react-i18next";
import ListPage from "../../../layouts/page/ListPage";
import { Columns } from "./Columns";
import MenuConfig from "../../../../constants/MenuConfig";
import { useState } from "react";
import Api from "../../../../constants/Api";
import { Col, FormLabel, Row } from "react-bootstrap";
import PageTitle from "../../../layouts/PageTitle";
import FilterAccordion from "../../../components/Common/Filter/FilterAccordion";
import InputText from "../../../components/Forms/Element/InputText";
import StatusFilterSelect, { DEFAULT_STATUS, buildStatusFilter } from "../../../components/Common/Filter/StatusFilterSelect";
import { SearchOperation } from "../../../../utils/ApiUtils";

const VendorList = () => {

    const { t } = useTranslation();
    const [nameFilter, setNameFilter] = useState('');
    const [phoneFilter, setPhoneFilter] = useState('');
    const [documentFilter, setDocumentFilter] = useState('');
    // A grade já abre só com ativos, então o select nasce em Ativo: o campo mostra o recorte
    // que está valendo em vez de parecer vazio.
    const [statusFilter, setStatusFilter] = useState(DEFAULT_STATUS);
    const [filters, setFilters] = useState([]);

    const handleSearch = () => {
        const activeFilters = [];

        if (nameFilter && nameFilter.trim()) {
            activeFilters.push({
                field: "name",
                value: nameFilter.trim(),
                operation: SearchOperation.MATCH
            });
        }
        
        if (phoneFilter && phoneFilter.trim()) {
            activeFilters.push({
                field: "phone",
                value: phoneFilter.trim(),
                operation: SearchOperation.MATCH
            });
        }
        
        if (documentFilter && documentFilter.trim()) {
            activeFilters.push({
                field: "document",
                value: documentFilter.trim(),
                operation: SearchOperation.MATCH
            });
        }

        activeFilters.push(buildStatusFilter(statusFilter));

        setFilters(activeFilters);
    };

    const handleClearFilters = () => {
        setNameFilter('');
        setPhoneFilter('');
        setDocumentFilter('');
        setStatusFilter(DEFAULT_STATUS);
        setFilters([]);
    };

    return (
        <>
            <PageTitle activeMenu={t("vendors")} motherMenu={t("main")} />

            <FilterAccordion
                title="filters"
                onSearch={handleSearch}
                onClear={handleClearFilters}
                centerButtons={false}
            >
                <Row className="g-2 align-items-end">
                    <Col lg={3} md={6}>
                        <FormLabel>{t('name')}</FormLabel>
                        <InputText
                            value={nameFilter}
                            onChange={(e) => setNameFilter(e.target.value)}
                            placeholder={t('name')}
                        />
                    </Col>
                    <Col lg={3} md={6}>
                        <FormLabel>{t('phone')}</FormLabel>
                        <InputText
                            value={phoneFilter}
                            onChange={(e) => setPhoneFilter(e.target.value)}
                            placeholder={t('phone')}
                        />
                    </Col>
                    <Col lg={3} md={6}>
                        <FormLabel>{t('cnpj')}</FormLabel>
                        <InputText
                            value={documentFilter}
                            onChange={(e) => setDocumentFilter(e.target.value)}
                            placeholder={t('cnpj')}
                        />
                    </Col>
                    <Col lg={3} md={6}>
                        <StatusFilterSelect value={statusFilter} onChange={setStatusFilter} />
                    </Col>
                </Row>
            </FilterAccordion>

            <ListPage
                showPageTitle={false}
                activeMenu={t("vendors")}
                motherMenu={t("main")}
                path={Api.main.vendor}
                route={MenuConfig.main.vendor.route}
                columns={Columns}
                filters={filters}
                hideInactiveToggle
            />
        </>
    );
}

export default VendorList;
